module.exports = __webpack_public_path__ + "static/media/gb.a95b4dcc.svg";